import { toSaveRequest } from './mappers';
import type { SaveProviderConfigInput } from './types';

/**
 * The API parses JSON bodies with body-parser's default limit of 100 KB and answers a larger
 * one with a bare 413, so a save is measured before it is sent.
 */
export const REQUEST_BODY_MAX_BYTES = 100 * 1024;

/** Whether the save fits the API's body limit, measured as the request it sends: UTF-8 JSON. */
export function saveRequestFits(input: SaveProviderConfigInput): boolean {
    const body = JSON.stringify(toSaveRequest(input));
    return new TextEncoder().encode(body).length <= REQUEST_BODY_MAX_BYTES;
}
